export const templateHiddenFields = {
  "Реквизиты АВТОВАЗ": [],
  "Руководство ДЦ": [
    "Фото руководителя - {PhotoBossId}",
    "Файл согласия на обработку персональных данных руководителя - {ScanBossPersonDataId}",
    "Файл согласия на обработку персональных данных Отв. за бренд ЛАДА - {ScanLadaPersonDataId}",
    "Файл согласия на обработку персональных данных бухгалтера - {ScanAccountantPersonDataId}",
  ],
  "Собственники ДЦ": [
    "Фото собственника - {PhotoOwnerId}",
    "Файл согласия на обработку персональных данных собственника - {ScanOwnerPersonDataId}",
  ],
  "Реквизиты дилерского центра": ["Код региона - {regionCode}"],
  "Поля для договора": [],
  "Основная информация о дилере": [
    "Новый дилер - {newDealer}",
    "Фото дилерского центра - {PhotoDealerCenterId}",
    "Статус - {status}",
  ],
  "Дополнительная информация": ["Скрыть на Lada.ru - {hideOnLadaRu}"],
  "Адреса дилерского центра": [
    "ID дома фактического адреса - {HouseId}",
    "ID дома юридического адреса - {legalHouseId}",
    "ID дома почтового адреса - {postalHouseId}",
    "Юридический адрес - {legalAddress}",
    "Почтовый адрес - {postalAddress}",
    "Страна - {country}",
    "Федеральный Округ - {FO}",
    "Область - {subject}",
    "Город - {city}",
    "Внутренний индентификатор документации - {ProjectDocumentationId}",
    "Логическое тип - {logicalType}",
    "Дата начала работы - {beginWorkingDate}",
    "Дата обновления - {updatedAt}",
    "Дата создания - {createdAt}",
  ],
};
